import { Field } from "./field.model";
import { ItemType } from "./request.model";

export const FieldsForm: { [key in ItemType]: Field[] } = {
  [ItemType.ASOCIACIONES]: [
    { name: 'id', type: 'number', value: '', label: 'Id', disabled: true },
    { name: 'cif', type: 'text', value: '', label: 'CIF' },
    { name: 'tipo_asociacion', type: 'select', value: '', label: 'Tipo de asociación', arrayKey: 'tipoAsociaciones' },
    { name: 'nombre', type: 'text', value: '', label: 'Nombre' },
    { name: 'lema', type: 'text', value: '', label: 'Lema' },
    { name: 'anyo_fundacion', type: 'number', value: '', label: 'Año de fundación' },
    { name: 'direccion', type: 'text', value: '', label: 'Dirección correo postal' },
    { name: 'telefono', type: 'text', value: '', label: 'Teléfono de contacto' },
    { name: 'email', type: 'email', value: '', label: 'e-mail' },
    { name: 'password', type: 'password', value: '', label: 'Contraseña', disabled: true },
    // El estado (activa / desactivada) ya no se edita con la ficha: tiene control, permiso y auditoría propios (P1.3 Wave 2.0).
    // { name: 'confirmPassword', type: 'password', value: '', label: 'Confirma la contraseña' }
  ],
  [ItemType.ASOCIADOS]: [
    { name: 'id', type: 'number', value: '', label: 'Id', disabled: true },
    { name: 'nif', type: 'text', value: '', label: 'NIF/NIE/SIP' },
    { name: 'nombre', type: 'text', value: '', label: 'Nombre' },
    { name: 'apellidos', type: 'text', value: '', label: 'Apellidos' },
    { name: 'telefono', type: 'text', value: '', label: 'Teléfono de contacto' },
    { name: 'email', type: 'text', value: '', label: 'e-mail' },
    { name: 'direccion', type: 'text', value: '', label: 'Dirección correo postal' },
    { name: 'codigo_postal', type: 'text', value: '', label: 'Código postal' },
    { name: 'fecha_nacimiento', type: 'date', value: '', label: 'Fecha de nacimiento' },
    { name: 'active', type: 'checkbox', value: '', label: 'Activo' },
    { name: 'password', type: 'password', value: '', label: 'Contraseña', disabled: true },
  ],
  [ItemType.EJERCICIOS]: [
    { name: 'id', type: 'number', value: '', label: 'Id', disabled: true },
    { name: 'ejercicio', type: 'number', value: '', label: 'Ejercicio' },
    { name: 'active', type: 'checkbox', value: '', label: 'Activo' },
  ],
  [ItemType.CARGOS]: [
    { name: 'id', type: 'number', value: '', label: 'Id', disabled: true },
    { name: 'nombre', type: 'text', value: '', label: 'Título del cargo' },
    { name: 'es_infantil', type: 'checkbox', value: '', label: 'Es un cargo infantil' },
    { name: 'obligatorio', type: 'checkbox', value: '', label: 'Es un cargo obligatorio' },
    { name: 'modo_ocupacion', type: 'select', value: 'multiple', label: 'Ocupación', options: [{ label: 'Múltiple', value: 'multiple' }, { label: 'Exclusivo (una persona por asociación)', value: 'exclusivo' }] },
    { name: 'maximo_personas', type: 'number', value: '0', label: 'Máximo de personas (0 = sin límite)' },
    { name: 'visible_ffsj', type: 'checkbox', value: '', label: 'Visible para FFSJ' },
    { name: 'visible_foguera', type: 'checkbox', value: '', label: 'Visible para Fogueras' },
    { name: 'visible_barraca', type: 'checkbox', value: '', label: 'Visible para Barracas' },
    { name: 'active', type: 'checkbox', value: '', label: 'Activo' },
  ],
  [ItemType.TIPOASOCIACIONES]: [
    { name: 'tipo', type: 'text', value: '', label: 'Tipo' },
    { name: 'id', type: 'number', value: '', label: 'Id', disabled: true },
  ],
  [ItemType.HISTORICO]: [
    { name: 'idAsociado', type: 'number', value: '', label: 'Id del Asociado', disabled: true },
    { name: 'idAsociacion', type: 'select', value: '', label: 'Asociación', arrayKey: 'asociaciones' },
    { name: 'idCargo', type: 'select', value: '', label: 'Cargo', arrayKey: 'cargos' },
    { name: 'ejercicio', type: 'select', value: '', label: 'Ejercicio', arrayKey: 'ejercicios' },
  ],
  [ItemType.POSTREQUESTASOCIADO]: [
    { name: 'id', type: 'number', value: '', label: 'Id', disabled: true },
    { name: 'nif', type: 'text', value: '', label: 'NIF/NIE/SIP' },
    { name: 'nombre', type: 'text', value: '', label: 'Nombre' },
    { name: 'apellidos', type: 'text', value: '', label: 'Apellidos' },
    { name: 'telefono', type: 'text', value: '', label: 'Teléfono de contacto' },
    { name: 'email', type: 'text', value: '', label: 'e-mail' },
    // { name: 'confirmPassword', type: 'password', value: '', label: 'Confirma la contraseña' },
    { name: 'direccion', type: 'text', value: '', label: 'Dirección correo postal' },
    { name: 'codigo_postal', type: 'text', value: '', label: 'Código postal' },
    { name: 'fecha_nacimiento', type: 'date', value: '', label: 'Fecha de nacimiento' },
    { name: 'active', type: 'checkbox', value: '', label: 'Activo' },
    { name: 'password', type: 'password', value: '', label: 'Contraseña', disabled: true },
  ],
  [ItemType.CARGOASOCIADOASOCIACION]: [],
  [ItemType.HISTORICOASOCIADO]: []
};

export const ExtraFieldsForm: { [key in ItemType]: Field[] } = {
  [ItemType.ASOCIACIONES]: [
    { name: 'confirmPassword', type: 'password', value: '', label: 'Confirma la contraseña', disabled: true },
  ],
  [ItemType.ASOCIADOS]: [
    { name: 'confirmPassword', type: 'password', value: '', label: 'Confirma la contraseña', disabled: true },
    { name: 'idAsociacion', type: 'select', value: '', label: 'Asociación', arrayKey: 'asociaciones' },
    { name: 'idCargo', type: 'select', value: '', label: 'Cargo', arrayKey: 'cargos' },
    { name: 'ejercicio', type: 'select', value: '', label: 'Ejercicio', arrayKey: 'ejercicios' },
  ],
  [ItemType.EJERCICIOS]: [],
  [ItemType.CARGOS]: [],
  [ItemType.TIPOASOCIACIONES]: [],
  [ItemType.HISTORICO]: [],
  [ItemType.POSTREQUESTASOCIADO]: [
    { name: 'confirmPassword', type: 'password', value: '', label: 'Confirma la contraseña', disabled: true },
    { name: 'idAsociacion', type: 'select', value: '', label: 'Asociación', arrayKey: 'asociaciones' },
    { name: 'idCargo', type: 'select', value: '', label: 'Cargo', arrayKey: 'cargos' },
    { name: 'ejercicio', type: 'select', value: '', label: 'Ejercicio', arrayKey: 'ejercicios' },
  ],
  [ItemType.CARGOASOCIADOASOCIACION]: [],
  [ItemType.HISTORICOASOCIADO]: []
};
